import './display.scss'
import { Button } from '@/shared/ui/Button/Button'
import errorImage from '@/shared/assets/images/error.png'

function Display() {
  return (
    <div className='display'>
      <div className='display__img'>
        <img src={errorImage} alt='404-Scarecrow' />
      </div>
      <div className='display__content'>
        <h2 className='display__content--info'>I have bad news for you</h2>
        <p className='display__content--text'>
          The page you are looking for might be removed or is temporarily
          unavailable
        </p>
        <Button
          type='primary'
          text='Back to homepage'
          className='btn'
          isLoading={false}
        />
      </div>
    </div>
  )
}

export default Display
